import React from 'react';
import AddressBookList from './AddressBookList';
import useAddressBook from '@Utils/hooks/useAddressBook';
import { dispatch } from '@Redux/store';
import { setActiveAddressBook, setNewAddressBook } from '@Redux/modules/addressBook/actions';
import { IAddress } from '@ApiModels/commerceProfile';
import { SelectedAddressType } from '../ShippingMethod';

export interface IFilterAddresses {
	addressBook: IAddress[];
	addressType: SelectedAddressType;
	filter: string | undefined;
	isPrepaidPurchase?: boolean | undefined;
}

const FilterAddresses = ({ addressBook, addressType, filter, isPrepaidPurchase }: IFilterAddresses): JSX.Element => {
	const { getTitle, removeAddress, editAddress, updateShippingAddress } = useAddressBook();

	const setToggleState = (address: IAddress, isChecked: boolean) => {
		updateShippingAddress(isChecked ? address : undefined);
		dispatch(
			setActiveAddressBook({
				activeAddressBook: isChecked ? address.addressId : undefined,
			})
		);
	};

	let data = addressBook;
	if (!!filter) {
		data = addressBook.filter((_addres) => _addres.addressId === filter);
		if (data.length <= 0) {
			setNewAddressBook({ newAddressBook: undefined });
		}
	}

	return (
		<AddressBookList
			addressBook={addressBook}
			addressType={addressType}
			editAddress={editAddress}
			data={data}
			filter={filter}
			getTitle={getTitle}
			isPrepaidPurchase={isPrepaidPurchase}
			removeAddress={removeAddress}
			setToggleState={setToggleState}
		/>
	);
};

export default FilterAddresses;
